export default {
  scale: {
    width: 0,
    height: 0
  },
  isShortSidebar: true
};